import React, { PropsWithChildren } from 'react';

function MainContent({ children }: PropsWithChildren) {
  return (
    <main className="relative flex-1 overflow-auto bg-gray0 px-10">
      {children}
    </main>
  );
}

export default MainContent;
